
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
// import store from './store';
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
// 引入所有图标并注册
import * as ElementPlusIconsVue from '@element-plus/icons-vue'


const app = createApp(App);

app.use(router);
// app.use(store);
app.use(ElementPlus);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

app.mount("#app");
// 在入口文件（如main.js）添加
if (process.env.NODE_ENV === 'development') {
    const originalError = console.error;
    console.error = (...args) => {
        if (!args[0].includes('ResizeObserver loop completed with undelivered notifications')) {
            originalError.call(console, ...args);
        }
    };
}
